import { apiService } from '../../api-base'
import { RealtimeTokenResponse } from './types'

export class RealtimeService {
  static getConnectionToken(accessToken: string) {
    return apiService.post<RealtimeTokenResponse>(
      '/realtime/token',
      undefined,
      {
        headers: {
          'X-Auth-Token': accessToken,
        },
        silentForbidden: true,
      },
    )
  }
}
